module.exports = __webpack_public_path__ + "img/anyBNB.4def8dd2.svg";